import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DashboardPreviewDetailsDto, PublishedReportItemType } from 'src/app/services/api.services';

@Component({
  selector: 'app-home-item-selector',
  templateUrl: './home-item-selector.component.html',
  styleUrls: ['./home-item-selector.component.scss'],
  standalone: false
})
export class HomeItemSelectorComponent implements OnChanges {
  @Input() busy: boolean = false;
  @Input() categories: HomeItemSelectorCategory[] = null;
  @Input() currentItem: HomeItemSelectorItem;

  @Output() itemSelected = new EventEmitter<HomeItemSelectorItem>();
  @Output() close = new EventEmitter();
  selectedCategory: HomeItemSelectorCategory;
  selectedSubCategory: HomeItemSelectorSubCategory;
  selectedItem: HomeItemSelectorItem;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentItem || changes.categories) {
      if (this.currentItem && this.categories) {
        this.selectedItem = this.currentItem;
        this.updateSelectionFromSelectedItem();
      }
    }
  }

  // Sets selected category and sub category from an item
  private updateSelectionFromSelectedItem() {
    let selection =
      this.selectedItem && this.categories.map(category => {
        let subCategory = category.subCategories.find(sc => !!sc.items.find(i => i === this.selectedItem));
        return subCategory ? { category, subCategory } : null;
      }).find(x => !!x);

    this.selectedCategory = selection?.category;
    this.selectedSubCategory = selection?.subCategory;
  }

  selectSubCategory(subCategory) {
    this.selectedSubCategory = subCategory;
    this.selectedItem =  this.selectedSubCategory.items[0];
  }

  selectItem(item) {
    this.selectedItem = item;
  }

  setCurrentItem() {
    this.itemSelected.emit(this.selectedItem);
    this.close.emit();
  }
}

export interface HomeItemSelectorCategory {
  name: string,
  icon: string
  subCategories: HomeItemSelectorSubCategory[]
}

export interface HomeItemSelectorSubCategory {
  name: string,
  icon: string,
  items: HomeItemSelectorItem[]
}

export interface HomeItemSelectorItem {
  itemId: number;
  itemType: PublishedReportItemType;
  name: string,
  dashboardPreview?: DashboardPreviewDetailsDto;
  visualPreviewUrl?: string;
}
